<template>
  <v-container>
    <v-card>
      <v-card-title>Activity History</v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="activities"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:item.performedAt="{ item }">
            {{ formatDate(item.performedAt) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { api } from '@/services/api'

// todo aram move this to views folder, also maybe change the url to /activity instead of /activity-history

interface Activity {
  partitionKey: string
  rowKey: string
  timestamp: string
  eTag: string
  customerId: string
  activityType: string
  description: string
  performerName: string
  performerEmail: string
  performedAt: string
  additionalData: string
}

const activities = ref<Activity[]>([])
const loading = ref(false)

const headers = [
  { title: 'Date', key: 'performedAt', sortable: true },
  { title: 'Performer', key: 'performerName', sortable: true },
  { title: 'Activity Type', key: 'activityType', sortable: true },
  { title: 'Description', key: 'description', sortable: true }
]

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleString()
}

const fetchActivities = async () => {
  loading.value = true
  try {
    const response = await api.getActivities()
    activities.value = response
  } catch (error) {
    console.error('Error fetching activities:', error)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchActivities()
})
</script> 